import typoMixin from '@/styles/mixins/typo-mixin'
import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  modalContainer: ({ typography, colors }) => css`
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 500px;
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 25px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 25px;
    }
    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }
    > p {
      margin-top: 24px;
      color: ${colors.neutral[900]};
    }

    > div {
      display: flex;

      .hero-link__label {
        display: flex;
        align-items: center;

        > span {
          display: block;
          margin-left: 8px;
          ${typoMixin({ typography }, 'button3')};
        }
      }
    }
    section {
      margin-top: 32px;

      .container-link {
        padding: 0 8px;
        margin-top: 16px;
      }
      .container-link-support {
        margin-top: 16px;
        padding: 0 8px;
      }

      .hero-collapsible {
        max-width: 688px;

        &--closed {
          height: 56px;
        }

        + .hero-collapsible {
          margin-top: 16px;
        }

        &__toggler {
          height: 56px;
          border-color: ${colors.primary[500]};
          background-color: ${colors.primary[100]};
          box-shadow: none;

          &--opened {
            border-bottom: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
        }

        &__content {
          top: 0;
          padding: 12px 24px;
          border-top: none;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          border-color: ${colors.primary[500]};
          background-color: ${colors.primary[100]};
          box-shadow: none;
        }

        &__label {
          color: ${colors.common.black};
        }
      }
    }
  `,
  modalFooter: () => css`
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;
  `,
})

export { useStyles }
